import React from 'react';
import {
  Box, Container, styled, ThemeProvider,
} from '@material-ui/core';
import { useParams } from 'react-router-dom';

import { SleepioHeader } from '../Onboarding/components/Header/SleepioHeader';
import SoleraAccountCreation from './SoleraAccountCreation';

import { Footer } from '../Onboarding/components/Footer/Footer';

import theme from '@/themes/sleepioTheme';
import { Product } from '@/utils/productHelpers';
import { useConsent } from '@/hooks/useConsent';

export type SoleraAccountCreationParams = {
  product: Product;
}

const ContentContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  minHeight: '100vh',
});

const SoleraAccountCreationPage = () => {
  useConsent();
  useParams<SoleraAccountCreationParams>();

  return (
    <ContentContainer>
      <Container maxWidth="sm">
        <SoleraAccountCreation />
      </Container>
      <Footer />
    </ContentContainer>
  );
};

export default () => (
  <ThemeProvider theme={theme}>
    <SleepioHeader />
    <SoleraAccountCreationPage />
  </ThemeProvider>
);
